import EntityType from '@/models/Shared/EntityType';
// Activity entity types use the standard ENTITY_TYPE values from the backend
// These values MUST match the ENTITY_TYPE constants in api/core/constants.go
enum ActivityEntityType {
    Worker = EntityType.Worker,
    Company = EntityType.Company,
    Location = EntityType.Location,
    Contact = EntityType.Contact,
    Booking = EntityType.Booking,
    Job = EntityType.Job,
    Opportunity = EntityType.Opportunity
}

export default ActivityEntityType;

export const ActivityEntityTypeLabels: { [key: number]: string } = {
    [ActivityEntityType.Worker]: 'Worker',
    [ActivityEntityType.Company]: 'Company',
    [ActivityEntityType.Location]: 'Location',
    [ActivityEntityType.Contact]: 'Contact',
    [ActivityEntityType.Booking]: 'Booking',
    [ActivityEntityType.Job]: 'Job',
    [ActivityEntityType.Opportunity]: 'Opportunity'
};
